import React from 'react';
import VenturiLoader from './VenturiLoader';

/**
 * LoadingSpinner Component
 * Legacy wrapper rendering the unified VenturiLoader under the hood.
 * 
 * @param {Object} props
 * @param {string} props.size - Size ('small' | 'medium' | 'large')
 * @param {string} props.message - Loading message
 * @param {string} props.color - Legacy theme color
 * @param {string} props.className - Extra CSS class
 * @param {boolean} props.inline - Inline flag
 */
const LoadingSpinner = ({ 
  size = 'medium', 
  message = 'Loading...', 
  color = 'primary',
  className = '',
  inline = false
}) => {
  return (
    <VenturiLoader
      size={size}
      message={message}
      className={className}
      overlay={!inline && size === 'large'}
    />
  );
};

export default LoadingSpinner;